export const SET_ZOOM_INTERVAL = 'SET_ZOOM_INTERVAL'
export const COM_ZOOM_IN = 'COM_ZOOM_IN'
export const COM_ZOOM_OUT = 'COM_ZOOM_OUT'